export default __webpack_public_path__ + "static/media/1.f41d658d.png";